module.exports = __webpack_public_path__ + "img/pm_11.9b2f8c64.png";